import {
  ArrowLeftOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  LoadingOutlined,
  SearchOutlined,
  UsergroupAddOutlined
} from "@ant-design/icons";
import { Avatar, Badge, Col, Input, message, Popconfirm, Popover, Result, Spin } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import React, { FC, useEffect, useRef, useState } from "react";
import Linkify from "react-linkify";
import { useDispatch, useSelector } from "react-redux";

//!ASSETS
import TeacherIcon from "assets/images/teacher/teacher.svg";
import { ReactComponent as Albert } from "../../../../assets/images/albert/albert_empty_conversation.svg";
import { ReactComponent as AlbertSearch } from "../../../../assets/images/albert/albert_insta_prof.svg";

import PlanningButtonIcon from "../../../../assets/images/app/calendar_icon.svg";
import MoreOptions from "../../../../assets/images/app/chat_options.svg";
import Organism from "../../../../assets/images/app/home/organisation.svg";
import Parent from "../../../../assets/images/app/home/parent.svg";
import InstaIcon from "../../../../assets/images/app/insta_icon.svg";
import NoSeenIcon from "../../../../assets/images/app/no_seen_icon.svg";
import ReportIcon from "../../../../assets/images/app/report_icon.png";
import SeenIcon from "../../../../assets/images/app/seen_icon.svg";
import UserBlockIcon from "../../../../assets/images/app/user_lock_icon.svg";

import moment from "moment";
import { setCurrentChat } from "store/AppChat/appChat";

//!STYLE
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios from "axios";
import { StatusCode, useBackForwardHandler, UserRoles } from "common/enums";
import TeacherCalendarForStudent from "screens/student/components/calendarTeacher";
import DrawerSearchInstaProf from "screens/student/searchTeacher/drawerSearchInstaProf";
import { displayReportDrawer, setReportedUserData, setReportingUserData } from "store/adventissements";
import s from "./assets/style/chat.module.css";

type Props = {
  conversation: any;
  isTyping: boolean;
  isBlocked: boolean;
  setIsBlocked: React.Dispatch<any>;
  isAttachment: boolean;
};

const ChatSpace: FC<Props> = ({ conversation, isTyping, isBlocked, setIsBlocked, isAttachment }) => {
  //!HOOKS
  const dispatch = useDispatch();
  const { idSender, idReceiver, currentChat, startChat, socket, talkId } = useSelector(
    (state) => state.appChat
  );
  const { user } = useSelector((state) => state.auth);
  const { isChatInstaProf } = useSelector((state) => state.room);
  const refChat = useRef<any>();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const isParent = user?.roles.includes(UserRoles.PARENT);
  const isOrganism = user?.roles.includes(UserRoles.ORGANISME);

  const [openDrawerInstaProf, setOpenDrawerInstaProf] = useState<boolean>(false);
  const [showDrawerTeacherCalendar, setShowDrawerTeacherCalendar] = useState<boolean>(false);
  const [teacherData, setTeacherData] = useState<any>();
  const [teacherID, setTeacherID] = useState<any>();
  const [blockerId, setBlockerId] = useState<any>();

  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [isUserOnline, setIsUserOnline] = useState<boolean>(false);

  const [isBtnInstaProf, setIsBtnInstaProf] = useState<boolean>(true);
  const showDrawerSearchInstaProf = () => {
    setOpenDrawerInstaProf(!openDrawerInstaProf);
  };

  const onShowDrawerTeacherCalendar = () => {
    localStorage.setItem("level", user?.levelId);
    setShowDrawerTeacherCalendar(true);
  };

  const getTeacherData = async (teacherId: string) => {
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
      setTeacherData(response?.data);
    } catch (error: any) { }
  };

  const [isBlocking, setIsBlocking] = useState<boolean>(false);

  const [isSearching, setIsSearching] = useState(false);
  const [visibleBlock, setVisibleBlock] = useState(false);
  const [visibleReport, setVisibleReport] = useState(false);
  const [visibleOptions, setVisibleOptions] = useState(false);
  const [filteredMessages, setFilteredMessages] = useState([]);

  const [isSearchingTeacher, setIsSearchingTeacher] = useState<boolean>(false);
  const [closeInstaprof, setCloseInstaprof] = useState<boolean>(false);

  // Prevent router nav
  useBackForwardHandler(isSearchingTeacher, () => {
    console.log("User attempted to navigate while searching");
  });

  // Prevent reload/close
  useEffect(() => {
    if (!openDrawerInstaProf && !isSearchingTeacher) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      setCloseInstaprof(true);
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [openDrawerInstaProf, isSearchingTeacher]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visibleReport, visibleBlock]);

  useEffect(() => {
    refChat?.current?.scrollIntoView({
      behavior: "smooth",
    });
    if (currentChat?.receiverId?.roles[0] === "teacher") {
      setTeacherID(currentChat?.receiverId?._id);
      getTeacherData(currentChat?.receiverId?._id);
    }
    else {
      setTeacherID(currentChat?.senderId?._id);
      getTeacherData(currentChat?.senderId?._id);
    }
  }, [conversation, isTyping, currentChat]);

  useEffect(() => {
    if (conversation && currentChat && user) {
      checkBlocking();
    }
  }, [conversation, currentChat, user]);

  useEffect(() => {
    socket?.on("userBlocked", async (msgResponse: any) => {
      checkBlocking();
    });
    socket?.on("userUnblocked", async (msgResponse: any) => {
      checkBlocking();
    });
  }, [socket]);

  const showPopconfirmReport = () => {
    setVisibleReport(true);
    setVisibleOptions(false);
  };

  const showPopconfirmBlock = () => {
    setVisibleBlock(true);
    setVisibleOptions(false);
  };

  const showReportDrawer = () => {
    const reportingUser = {
      "id": user?._id,
      "name": user?.firstname + " " + user?.lastname,
      "role": user?.roles[0]
    };

    const reportedUser = {
      "id": user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?._id : currentChat?.senderId?._id,
      "name": user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?.firstname + " " + currentChat?.receiverId?.lastname : currentChat?.senderId?.firstname + " " + currentChat?.senderId?.lastname,
      "role": user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?.roles[0] : currentChat?.senderId?.roles[0]
    };
    dispatch(setReportingUserData(reportingUser));
    dispatch(setReportedUserData(reportedUser));
    setVisibleReport(false);
    dispatch(displayReportDrawer(true));
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
      {(user?._id === currentChat?.senderId?._id && currentChat?.receiverId?.roles[0] === "teacher" || user?._id === currentChat?.receiverId?._id && currentChat?.senderId?.roles[0] === "teacher") && <div onClick={onShowDrawerTeacherCalendar} style={{ fontSize: isMobile ? "0.8em" : "13px", color: "#393E3E", cursor: "pointer", display: "flex", flexDirection: "row" }}>
        <div style={{ height: 20, width: 20, border: "1px solid #80b1b2", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF", marginRight: "5px" }}>
          <img src={PlanningButtonIcon} style={{ height: "15px" }}></img>
        </div>
        Calendrier
      </div>}
      {(user?._id === currentChat?.senderId?._id && currentChat?.receiverId?.roles[0] === "teacher" && teacherData?.teacher?.instaProf || user?._id === currentChat?.receiverId?._id && currentChat?.senderId?.roles[0] === "teacher" && teacherData?.teacher?.instaProf) && <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>}
      {(user?._id === currentChat?.senderId?._id && currentChat?.receiverId?.roles[0] === "teacher" && teacherData?.teacher?.instaProf || user?._id === currentChat?.receiverId?._id && currentChat?.senderId?.roles[0] === "teacher" && teacherData?.teacher?.instaProf) && <div onClick={showDrawerSearchInstaProf} style={{ fontSize: isMobile ? "0.8em" : "13px", color: "#393E3E", cursor: "pointer", display: "flex", flexDirection: "row" }}>
        <div style={{ height: 20, width: 20, border: "1px solid #ffc8ba", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF", marginRight: "5px" }}>
          <img src={InstaIcon} style={{ height: "100%" }} ></img>
        </div>
        InstaProf
      </div>}
      {(user?._id === currentChat?.senderId?._id && currentChat?.receiverId?.roles[0] === "teacher" || user?._id === currentChat?.receiverId?._id && currentChat?.senderId?.roles[0] === "teacher") && <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>}
      <div onClick={showPopconfirmReport} style={{ fontSize: isMobile ? "0.8em" : "13px", color: "#393E3E", cursor: "pointer", display: "flex", flexDirection: "row" }}>
        <div style={{ height: 20, width: 20, border: "1px solid #d63333", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF", marginRight: "5px" }}>
          <img src={ReportIcon} height={25} ></img>
        </div>
        Signaler ce profil
      </div>
      <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>
      {!isBlocked && <div onClick={showPopconfirmBlock} style={{ fontSize: isMobile ? "0.8em" : "13px", color: "#F56666", cursor: "pointer", display: "flex", flexDirection: "row" }}>
        <div style={{ height: 20, width: 20, border: "1px solid #de5150", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF", marginRight: "5px" }}>
          <img src={UserBlockIcon} style={{ height: "10px" }} ></img>
        </div>
        Bloquer
      </div>}
      {isBlocked && blockerId === user?._id && <div onClick={showPopconfirmBlock} style={{ fontSize: isMobile ? "0.8em" : "13px", color: "#F56666", cursor: "pointer", display: "flex", flexDirection: "row" }}>
        <div style={{ height: 20, width: 20, border: "1px solid #de5150", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF", marginRight: "5px" }}>
          <img src={UserBlockIcon} style={{ height: "10px" }} ></img>
        </div>
        Débloquer
      </div>}
    </div>
  );

  const handleCancelBlock = () => {
    setVisibleBlock(false);
  };

  const handleCancelReport = () => {
    setVisibleReport(false);
  };

  const checkBlocking = async () => {
    try {
      const myId = user._id;
      const userId = user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?._id : currentChat?.senderId?._id;
      const response = await axios.get(`${API_RESSOURCES}/abuse-reports/${myId}/blocked/${userId}`);
      if (response.status === StatusCode.OK) {
        const payloadData = response?.data?.data;
        if (payloadData?.isBlocked) {
          setIsBlocked(true);
          setBlockerId(payloadData?.blockerId);
        }
        else {
          setIsBlocked(false);
        }
      }
    } catch (error) { }
  }

  const blockUser = async (values: any) => {
    try {
      setVisibleBlock(false);
      setIsBlocking(true);
      const myId = user._id;
      const userId = user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?._id : currentChat?.senderId?._id;
      const response = await axios.post(`${API_RESSOURCES}/abuse-reports/block`, { myId, userId });
      if (response.status === StatusCode.CREATED) {
        message.success("Utilisateur bloqué avec succès");
        setIsBlocked(true);
        sendBlocking();
        checkBlocking();
      }
    } catch (error) { }
    finally {
      setIsBlocking(false);
    }
  }

  const unblockUser = async (values: any) => {
    try {
      setVisibleBlock(false);
      setIsBlocking(true);
      const myId = user._id;
      const userId = user?._id === currentChat?.senderId?._id ? currentChat?.receiverId?._id : currentChat?.senderId?._id;
      const response = await axios.put(`${API_RESSOURCES}/abuse-reports/${myId}/unblock/${userId}`);
      if (response.status === StatusCode.OK) {
        message.success("Utilisateur débloqué avec succès");
        setIsBlocked(false);
        sendUnblocking();
        checkBlocking();
      }
    } catch (error) { }
    finally {
      setIsBlocking(false);
    }
  }

  const sendBlocking = async () => {
    socket?.connect();
    await socket.emit("userBlock", talkId);
  };

  const sendUnblocking = async () => {
    socket?.connect();
    await socket.emit("userUnblock", talkId);
  };

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (visibleReport || visibleBlock) {
          console.log("Action selected!");
        } else {
          setVisibleOptions(false);
        }
      }
    }, 200);
  };

  const handleMessageSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    if (value.length >= 3) {
      setIsSearching(true);
      // Filter messages based on input
      const filtered = conversation.filter((chat: any) =>
        chat.message.toLowerCase().includes(value)
      );
      setFilteredMessages(filtered);
    }
    else {
      setIsSearching(false);
      setFilteredMessages([]);
    }
  }

  const handleCancelSearch = () => {
    setIsSearching(false);
    setFilteredMessages([]);
  }

  // Helper function to get the actual ID from either an object or string
  const getSenderId = (sender: any) => {
    return typeof sender === 'string' ? sender : sender?._id;
  };

  // Format file size
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  // Get file icon based on mime type
  const getFileIcon = (mimeType: string) => {
    if (mimeType.includes('pdf')) {
      return <FilePdfOutlined style={{ fontSize: '32px', color: '#ff4d4f' }} />;
    } else if (mimeType.includes('word') || mimeType.includes('document')) {
      return <FileWordOutlined style={{ fontSize: '32px', color: '#1890ff' }} />;
    } else if (mimeType.includes('excel') || mimeType.includes('sheet')) {
      return <FileExcelOutlined style={{ fontSize: '32px', color: '#52c41a' }} />;
    }
    return <FileOutlined style={{ fontSize: '32px', color: '#595959' }} />;
  };

  // Render attachment based on type
  const renderAttachment = (attachment: any) => {
    if (!attachment) return null;

    const isImage = attachment.mimeType?.startsWith('image/');

    if (isImage) {
      // Render image
      return (
        <div className={s.attachmentContainer}>
          <a href={attachment.url} target="_blank" rel="noopener noreferrer">
            <img
              src={attachment.url}
              alt={attachment.fileName}
              className={s.attachmentImage}
            />
          </a>
        </div>
      );
    } else {
      // Render file (PDF, Word, Excel)
      return (
        <div className={s.attachmentContainer}>
          <a
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            className={s.fileAttachment}
          >
            <div className={s.fileIcon}>
              {getFileIcon(attachment.mimeType)}
            </div>
            <div className={s.fileInfo}>
              <div className={s.fileName}>{attachment.fileName}</div>
              <div className={s.fileSize}>{formatFileSize(attachment.size)}</div>
            </div>
            <DownloadOutlined className={s.downloadIcon} />
          </a>
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <div className={`${isAttachment ? s.chat__space_attachment : s.chat__space} ${currentChat?.instaProf && s.isInsta}`}>
        {startChat && <div className={s.header}>
          <div
            className={s.back}
            onClick={() => dispatch(setCurrentChat(null))}
          >
            <ArrowLeftOutlined style={{ fontSize: "1em" }} />
          </div>
          <span>
            <React.Fragment>
              {currentChat?.receiverIdC ? (
                <span>
                  {currentChat?.receiverIdC?.title}
                </span>
              ) : (
                <React.Fragment>
                  {!isMobile ? <div className={s.receiverDetails}>
                    {/* Avatar And Name */}
                    <div className={s.receiverNameAvatarBox}>
                      <Avatar
                        size={45}
                        style={{
                          height: "45px",
                          width: "45px"
                        }}
                        src={
                          currentChat?.receiverIdC ? (
                            <UsergroupAddOutlined
                              style={{
                                color: "var(--first-color)",
                                fontSize: "26px",
                              }}
                            />
                          ) : user?._id === currentChat?.receiverId?._id ? (
                            currentChat?.senderId?.profile || (currentChat?.senderId?.roles[0] === "organisme" ? Organism : currentChat?.senderId?.roles[0] === "parent" ? Parent : TeacherIcon)
                          ) : (
                            currentChat?.receiverId?.profile || (currentChat?.receiverId?.roles[0] === "organisme" ? Organism : currentChat?.receiverId?.roles[0] === "parent" ? Parent : TeacherIcon)
                          )
                        }
                      />
                      {user?._id === currentChat?.receiverId?._id && <div className={s.nameStatusBox}>
                        {currentChat?.senderId?.firstname?.split(" ")[0]}{" "} {currentChat?.senderId?.lastname}
                        {currentChat?.senderId?.roles?.includes("organisme") && `(${currentChat?.senderId?.organisationName})`}
                        <span>{currentChat?.senderId?.pseudo}</span>
                        <div className={isUserOnline ? s.activeUser : s.inactiveUser} style={{ visibility: "hidden" }}>{isUserOnline ? <><Badge color="lime" style={{ position: "relative", bottom: "3.5px" }} /> Actif</> : <><Badge status="error" style={{ position: "relative", bottom: "3.5px" }} /> Inactif</>}</div>
                      </div>}
                      {user?._id !== currentChat?.receiverId?._id && <div className={s.nameStatusBox}>
                        {currentChat?.receiverId?.firstname?.split(" ")[0]}{" "} {currentChat?.receiverId?.lastname}
                        {currentChat?.receiverId?.roles?.includes("organisme") && `(${currentChat?.receiverId?.organisationName})`}
                        <span>{currentChat?.receiverId?.pseudo}</span>
                        <div className={isUserOnline ? s.activeUser : s.inactiveUser} style={{ visibility: "hidden" }}>{isUserOnline ? <><Badge color="lime" style={{ position: "relative", bottom: "3.5px" }} /> Actif</> : <><Badge status="error" style={{ position: "relative", bottom: "3.5px" }} /> Inactif</>}</div>
                      </div>}
                    </div>
                    {/* Search Box Buttons */}
                    <div className={s.searchBoxButtons}>
                      <div className={s.searchBox}>
                        <Input
                          onChange={handleMessageSearch}
                          placeholder="Chercher un message"
                          style={{ width: "100%" }}
                          bordered={false}
                          allowClear={true}
                          onReset={handleCancelSearch}
                        />
                        <SearchOutlined style={{ fontSize: "15px" }} />
                      </div>
                      <Popover
                        visible={visibleOptions}
                        placement="left"
                        content={content}
                        trigger="click"
                        style={{ height: "70px !important", width: "350px !important", borderRadius: "8px", boxShadow: "4px 8px 16px #8B8B8B38", border: "0.5px solid #BFBCBC" }}
                        className={s.customPopover}
                        overlayClassName={s.customPopover}
                      >
                        <div ref={popoverReportRef} className={s.optionButton} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={MoreOptions} height={17}></img></div>
                      </Popover>
                      <Popconfirm
                        placement="top"
                        title={
                          (isParent || isOrganism) ? "Êtes-vous sûr ?" : "Es-tu sûr ?"
                        }
                        onConfirm={isBlocked ? unblockUser : blockUser}
                        visible={visibleBlock}
                        okText={isBlocking ? <Spin size="small" /> : "Oui"}
                        cancelText="Non"
                        onCancel={handleCancelBlock}
                        okButtonProps={{ disabled: isBlocking }}
                      >
                      </Popconfirm>

                      <Popconfirm
                        placement="top"
                        title={
                          (isParent || isOrganism) ? "Êtes-vous sûr ?" : "Es-tu sûr ?"
                        }
                        onConfirm={showReportDrawer}
                        visible={visibleReport}
                        okText={"Oui"}
                        cancelText="Non"
                        onCancel={handleCancelReport}
                      >
                      </Popconfirm>
                    </div>
                  </div> : <div className={s.receiverDetails}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "90%", marginLeft: "10%" }}>
                      {/* Avatar And Name */}
                      <div className={s.receiverNameAvatarBox}>
                        <Avatar
                          size={35}
                          style={{
                            height: "35px",
                            width: "35px"
                          }}
                          src={
                            currentChat?.receiverIdC ? (
                              <UsergroupAddOutlined
                                style={{
                                  color: "var(--first-color)",
                                  fontSize: "26px",
                                }}
                              />
                            ) : user?._id === currentChat?.receiverId?._id ? (
                              currentChat?.senderId?.profile || (currentChat?.senderId?.roles[0] === "organisme" ? Organism : currentChat?.senderId?.roles[0] === "parent" ? Parent : TeacherIcon)
                            ) : (
                              currentChat?.receiverId?.profile || (currentChat?.receiverId?.roles[0] === "organisme" ? Organism : currentChat?.receiverId?.roles[0] === "parent" ? Parent : TeacherIcon)
                            )
                          }
                        />
                        {user?._id === currentChat?.receiverId?._id && <div className={s.nameStatusBox}>
                          {currentChat?.senderId?.firstname?.split(" ")[0]}{" "} {currentChat?.senderId?.lastname}
                          {currentChat?.senderId?.roles?.includes("organisme") && `(${currentChat?.senderId?.organisationName})`}
                          <span>{currentChat?.senderId?.pseudo}</span>
                          <div className={isUserOnline ? s.activeUser : s.inactiveUser} style={{ visibility: "hidden" }}>{isUserOnline ? <><Badge color="lime" style={{ position: "relative", bottom: "6px" }} /> Actif</> : <><Badge status="error" style={{ position: "relative", bottom: "6px" }} /> Inactif</>}</div>
                        </div>}
                        {user?._id !== currentChat?.receiverId?._id && <div className={s.nameStatusBox}>
                          {currentChat?.receiverId?.firstname?.split(" ")[0]}{" "} {currentChat?.receiverId?.lastname}
                          {currentChat?.receiverId?.roles?.includes("organisme") && `(${currentChat?.receiverId?.organisationName})`}
                          <span>{currentChat?.receiverId?.pseudo}</span>
                          <div className={isUserOnline ? s.activeUser : s.inactiveUser} style={{ visibility: "hidden" }}>{isUserOnline ? <><Badge color="lime" style={{ position: "relative", bottom: "6px" }} /> Actif</> : <><Badge status="error" style={{ position: "relative", bottom: "6px" }} /> Inactif</>}</div>
                        </div>}
                      </div>
                      <div className={s.searchBoxButtons}>
                        <Popover
                          visible={visibleOptions}
                          placement="left"
                          content={content}
                          trigger="click"
                          style={{ height: "70px !important", width: "350px !important", borderRadius: "8px", boxShadow: "4px 8px 16px #8B8B8B38", border: "0.5px solid #BFBCBC" }}
                          className={s.customPopover}
                          overlayClassName={s.customPopover}
                        >
                          <div ref={popoverReportRef} className={s.optionButton} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={MoreOptions} height={17}></img></div>
                        </Popover>
                      </div>
                    </div>
                    <div className={s.searchBox}>
                      <Input
                        className={s.searchField}
                        onChange={handleMessageSearch}
                        placeholder="Chercher un message"
                        style={{ width: "100%", fontSize: "0.8em" }}
                        bordered={false}
                        allowClear={true}
                        onReset={handleCancelSearch}
                      />
                      <SearchOutlined style={{ fontSize: "15px" }} />
                    </div>
                  </div>}
                </React.Fragment>
              )}
            </React.Fragment>
          </span>
        </div>}
        {isSearching && <div className={s.searchAnswersBox}>
          {filteredMessages && filteredMessages.length > 0 ? (
            filteredMessages.map((chat: any, index: number) => (
              <div key={index} className={`${s.chat__msg}`}>
                <div className={s.chat__msg__profile}>
                  <img
                    className={s.chat__msg__img}
                    src={
                      user?._id === chat?.receiverId?._id
                        ? chat?.senderId?.profile || (chat?.senderId?.roles[0] === "organisme" ? Organism : chat?.senderId?.roles[0] === "parent" ? Parent : TeacherIcon)
                        : chat?.receiverId?.profile || (chat?.receiverId?.roles[0] === "organisme" ? Organism : chat?.receiverId?.roles[0] === "parent" ? Parent : TeacherIcon)
                    }
                    alt=""
                  />
                </div>
                <div className={s.chat__msg__content}>
                  <div className={s.chat__msg__text_search}>
                    <span style={{ color: "var(--first-color)" }}>
                      {chat?.message}
                    </span>
                  </div>
                  <div className={s.chat__msg__date}>
                    {moment(chat?.createdAt).fromNow().replace(/^\w/, (c) => c.toUpperCase())}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
              Aucun messages trouvé
              <Result icon={<AlbertSearch className={s.albert} style={{ height: "120px" }} />} />
            </div>
          )}
        </div>}
        <div className={s.chat__content}>
          {startChat && conversation.length > 0 ? (
            <React.Fragment>
              {conversation?.map((c: any) => {
                const isOwner = user?._id === getSenderId(c?.sender || c?.senderId?._id);

                return (
                  <div key={c._id || c.createdAt} ref={refChat}>
                    <div className={`${s.chat__msg} ${isOwner ? s.owner : ""}`}>
                      <div className={s.chat__msg__profile}>
                        <img
                          className={s.chat__msg__img}
                          src={
                            typeof c?.senderId === 'string'
                              ? TeacherIcon
                              : c?.senderId?.profile
                                ? c?.senderId?.profile
                                : c?.senderId?.roles?.[0] === "organisme"
                                  ? Organism
                                  : c?.senderId?.roles?.[0] === "parent"
                                    ? Parent
                                    : TeacherIcon
                          }
                          alt=""
                        />
                      </div>
                      <div className={s.chat__msg__content}>
                        {/* Render Attachment First (if exists) */}
                        {c?.attachment && renderAttachment(c.attachment)}

                        {/* Render Text Message Below (if exists) */}
                        {c?.message && c?.message.trim() !== '' && (
                          <div className={s.chat__msg__text}>
                            <Linkify>{c?.message}</Linkify>
                          </div>
                        )}

                        {!isMobile && <div className={s.chat__msg__date}>
                          {moment(c?.createdAt).fromNow().replace(/^\w/, (c) => c.toUpperCase())}
                          <img src={c?.seen ? SeenIcon : NoSeenIcon} height={isMobile ? 7 : 10} style={{ marginLeft: "5px", marginTop: "5px" }}></img>
                        </div>}
                      </div>
                      {isMobile && <div className={s.chat__msg__date}>
                        {moment(c?.createdAt).fromNow().replace(/^\w/, (c) => c.toUpperCase())}
                        <img src={c?.seen ? SeenIcon : NoSeenIcon} height={isMobile ? 7 : 10} style={{ marginLeft: "5px", marginTop: "5px" }}></img>
                      </div>}
                      {c?.receiverIdC && (
                        <div>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "500",
                              color: "var(--first-color)",
                            }}
                          >
                            {typeof c.senderId === 'string' ? '' : `${c.senderId?.lastname} ${c.senderId?.firstname}`}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

              {isTyping && (
                <div className={`${s.chat__msg}`}>
                  <div className={s.chat__msg__profile}>
                    <img
                      className={s.chat__msg__img}
                      src={
                        user?._id === currentChat?.receiverId?._id
                          ? currentChat?.senderId?.profile || (currentChat?.senderId?.roles[0] === "organisme" ? Organism : currentChat?.senderId?.roles[0] === "parent" ? Parent : TeacherIcon)
                          : currentChat?.receiverId?.profile || (currentChat?.receiverId?.roles[0] === "organisme" ? Organism : currentChat?.receiverId?.roles[0] === "parent" ? Parent : TeacherIcon)
                      }
                      alt=""
                    />
                    <div className={s.chat__msg__date}>
                      <LoadingOutlined />
                    </div>
                  </div>
                  <div className={s.chat__msg__content}>
                    <div className={s.chat__msg__text}>
                      <span style={{ color: "var(--first-color)" }}>
                        En cours d'écrire
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {startChat ? (
                <Col>
                  {!isParent && !isOrganism && <div className={s.emptyChatTitle}>
                    Hey {" "} {user?.firstname} !
                    <span className={s.emptyChatSubtitle}>Commence une discussion avec<br /><b>{currentChat?.receiverIdC ? currentChat?.receiverIdC?.title : user?._id === currentChat?.receiverId?._id ? currentChat?.senderId?.firstname?.split(" ")[0] : currentChat?.receiverId?.firstname?.split(" ")[0]}{" "}</b></span>
                  </div>}
                  {isParent && isOrganism && <div className={s.emptyChatTitle}>
                    Bonjour {user?.firstname} !
                    <span className={s.emptyChatSubtitle}>Démarrez une discussion avec<br /><b>{currentChat?.receiverIdC ? currentChat?.receiverIdC?.title : user?._id === currentChat?.receiverId?._id ? currentChat?.senderId?.firstname?.split(" ")[0] : currentChat?.receiverId?.firstname?.split(" ")[0]}{" "}</b></span>
                  </div>}
                  <Result
                    icon={<Albert className={s.albert} />}
                  />
                </Col>
              ) : (
                <>
                  {!isParent && !isOrganism && <div className={s.emptyChatTitle}>
                    Hey {" "} {user?.firstname} !
                    <span className={s.emptyChatSubtitle}>Choisis une discussion</span>
                  </div>}
                  {isParent && isOrganism && <div className={s.emptyChatTitle}>
                    Bonjour {user?.firstname} !
                    <span className={s.emptyChatSubtitle}>Choisissez une discussion</span>
                  </div>}
                  <Result icon={<Albert className={s.albert} />} />
                </>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
      <TeacherCalendarForStudent
        open={showDrawerTeacherCalendar}
        setOpen={setShowDrawerTeacherCalendar}
        currentTeacher={teacherData}
      />

      <DrawerSearchInstaProf
        openDrawerInstaProf={openDrawerInstaProf}
        showDrawerSearchInstaProf={showDrawerSearchInstaProf}
        isBtnInstaProf={isBtnInstaProf}
        setIsBtnInstaProf={setIsBtnInstaProf}
        dataOfTeacher={teacherData}
        setIsSearching={setIsSearchingTeacher}
        closeInstaprof={closeInstaprof}
      />
    </React.Fragment>
  );
};

export default ChatSpace;